import { formatBigNumber } from "@quint/services/web3";
import { useConventionalPoolV2StakingDetails } from "@quint/services/web3/hooks/conventional-pool-v2";
import { Checkbox } from "@quint/ui";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@quint/ui/dialog";
import { useCallback, useState, type PropsWithChildren, type ReactElement } from "react";
import { useAccount } from "wagmi";
import Staking from "./staking";

interface UnstakeDialogProps {
  renderUnstakeButton: (value: number, fullUnstake: boolean) => ReactElement;
}

type FullUnstakeCheckboxProps = {
  fullUnstake: boolean;
  setFullUnstake: (v: boolean) => void;
  setValue: (v: number) => void;
};
const FullUnstakeCheckBox = (props: FullUnstakeCheckboxProps) => {
  const { address } = useAccount();
  const { data } = useConventionalPoolV2StakingDetails({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    args: [address!],
    enabled: Boolean(address),
  });
  const onCheckChanged = useCallback(
    (value: boolean) => {
      if (value) {
        props.setFullUnstake(value);
        props.setValue(+formatBigNumber(data?.tokenAmount));
      } else {
        props.setFullUnstake(value);
        props.setValue(0);
      }
    },
    [data, props]
  );

  return (
    <div className="flex shrink-0 items-center gap-4">
      <Checkbox checked={props.fullUnstake} onCheckedChange={onCheckChanged} />
      <p>Full Unstake</p>
    </div>
  );
};
export const UnstakeDialog = ({ renderUnstakeButton, children }: PropsWithChildren<UnstakeDialogProps>) => {
  const [value, setValue] = useState<number | undefined>(0);
  const [fullUnstake, setFullUnstake] = useState(false);

  return (
    <Dialog>
      <DialogTrigger className="w-full" asChild>
        {children}
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Notes</DialogTitle>
          <DialogDescription>
            <p className="text-[#677680] dark:text-[#B3BAC0]">
              *Unstaking within 15 days incurs a 15% penalty on your staking rewards.
            </p>
            <p className="text-[#677680] dark:text-[#B3BAC0]">*Please harvest rewards before partial unstaking.</p>
          </DialogDescription>
        </DialogHeader>
        <div className="my-8 h-[1px] w-full bg-[#E6E8EA] dark:bg-[#354856]" />
        <p className="mb-6 text-[#677680] dark:text-[#B3BAC0]">Please enter the unstake amount:</p>

        <div className="flex flex-col gap-4">
          <Staking.TokensInput value={value} setValue={setValue} disabled={fullUnstake} allowMax={false} />
          <FullUnstakeCheckBox fullUnstake={fullUnstake} setFullUnstake={setFullUnstake} setValue={setValue} />
        </div>
        <div className="mt-6 flex justify-end">
          {renderUnstakeButton(value || 0, fullUnstake)}
          {/* {isValidElement(unstakeButton) ? cloneElement(unstakeButton, { value: value || 0, fullUnstake }) : null} */}
        </div>
      </DialogContent>
    </Dialog>
  );
};
